import ApiService from '@/core/services/api.service';

const commonMixin = {
  created: function () {},
  methods: {
    fetchStores: async function () {
      const params = {
        getFull: true,
      };
      return ApiService.query('/stores', {
        params: params,
      }).then((response) => {
        return response.data;
      });
    },
    fetchOrderSources() {
      const params = {
        status: 1,
        getFull: true,
      };
      return ApiService.query(`order-sources`, {
        params: params,
      }).then((response) => {
        return response.data;
      });
    },
  },
};
export default commonMixin;
